module.exports = __webpack_public_path__ + "img/check-outline-green-bg.65040cf6.svg";